import { createClasses } from "@bloomberg/media-ui-core";
import React from "react";
import { PropsWithClassAndChildren } from "../types";

import styles from "./GridRightContent.module.css";

export function GridRightContent({
  children,
  className,
  ...args
}: PropsWithClassAndChildren) {
  const cx = createClasses([styles.gridRightContent, className]);

  return (
    <aside className={cx} {...args}>
      {children}
    </aside>
  );
}
